import React from "react";
import { Card, Button, ProgressBar } from "react-bootstrap";

const BillingSubscription = () => {
  const subscriptionData = {
    plan: "Basic Plan",
    billingCycle: "Monthly",
    price: 97.50,
    minutesUsed: 25,
    totalMinutes: 600,
    description: "Our most popular plan for small team"
  };

  return (
    <Card className="custom-card-bg shadow-sm border-0 p-4 rounded-4 mb-4">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h5 className="mb-2">Subscription</h5>
          <div className="d-flex align-items-center gap-2">
            <h6 className="mb-0">{subscriptionData.plan}</h6>
            <span className="badge bg-primary rounded-pill">{subscriptionData.billingCycle}</span>
          </div>
          <p className="text-muted small mb-0 mt-1">{subscriptionData.description}</p>
        </div>
        <div className="text-end">
          <h3 className="mb-0">${subscriptionData.price}</h3>
          <span className="text-muted small">per month</span>
        </div>
      </div>

      <ProgressBar 
        now={(subscriptionData.minutesUsed/subscriptionData.totalMinutes) * 100} 
        variant="primary" 
        className="mb-2"
      />
      <p className="small text-muted mb-4">
        {subscriptionData.minutesUsed} of {subscriptionData.totalMinutes} mins left
      </p>

      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted">Need more minutes?</span>
          <Button variant="outline-secondary" size="sm" className="support-button">
            <img 
              src="/assets/life-buoy.svg" 
              alt="life buoy" 
              className="icon-svg"
            />{" "}
            Contact Support
          </Button>
        </div>
        <Button 
          variant="link" 
          className="d-flex text-primary text-decoration-none gap-3"
        >
          <img src="/assets/arrow-up-right.svg" alt="Up Right" className="mb-2" />{" "}
          <h5  style={{ color: '#5925DC' }}>Upgrade</h5>
        </Button>
      </div>
    </Card>
  );
};

export default BillingSubscription;